var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 49 49",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.471 29.946a9.514 9.514 0 00-7.838 4.132l-13.29-6c.945-2.28.948-4.84.011-7.122l13.27-6.03a9.514 9.514 0 10-1.688-5.397c.01.539.064 1.075.164 1.605l-14.108 6.41a9.53 9.53 0 10-.03 13.939l14.144 6.386a9.677 9.677 0 00-.161 1.603 9.528 9.528 0 109.526-9.526zm0-25.862a5.445 5.445 0 11.004 10.89 5.445 5.445 0 01-.004-10.89zM9.528 29.946a5.446 5.446 0 115.443-5.446 5.451 5.451 0 01-5.443 5.446zm29.943 14.971a5.445 5.445 0 110-10.89 5.445 5.445 0 010 10.89z",
    fill: "currentColor"
  })));
};

export default SvgClipboard;